import React from "react";
import ShopifySVG from "../../../../assets/svg/shopify.svg";
import Modal from "../../../../components/common/Modal";

const ShopifyGuideModal = ({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) => {
  return (
    <Modal
      width={750}
      onRequestClose={onRequestClose}
      isOpen={true}
    >
      <div className="max-w-3xl px-4 pt-4 pb-6 md:px-8 md:pt-8 md:pb-10">
        <div className="flex items-center gap-3">
          <img
            alt="shopify-logo"
            src={ShopifySVG}
            width={40}
            height={40}
          />
          <h2 className="text-xl font-semibold mb-2">
            Setup a Shopify Access Token
          </h2>
        </div>

        <p className="mb-4">
          Follow these steps to create a private app in Shopify and generate an
          access token for use with ArticleX.
        </p>
        <ol className="list-decimal list-inside space-y-2">
          <li>Go to your Shopify admin dashboard.</li>
          <li>
            Click <strong>Settings</strong> (bottom-left corner).
          </li>
          <li>
            Select <strong>Apps and sales channels</strong>.
          </li>
          <li>
            Click <strong>Develop apps</strong> in the top right corner.
          </li>
          <li>
            If prompted, click <strong>Allow custom app development</strong>.
          </li>
          <li>
            Click <strong>Create an app</strong>.
          </li>
          <li>
            Enter an app name (e.g. <em>ArticleX Integration</em>) and click{" "}
            <strong>Create app</strong>.
          </li>
          <li>
            Go to the <strong>Configuration</strong> tab and click{" "}
            <strong>Configure Admin API scopes</strong>.
          </li>
          <li>
            Scopes Required:
            <ul className="list-disc list-inside ml-5">
              <li>
                <code>write_content</code>
              </li>
              <li>
                <code>read_content</code>
              </li>
              <li>
                <code>write_files</code>
              </li>
              <li>
                <code>read_files</code>
              </li>
            </ul>
          </li>
          <li>
            Click <strong>Save</strong>.
          </li>
          <li>
            Go to the <strong>API credentials</strong> tab.
          </li>
          <li>
            Click <strong>Install app</strong>, then confirm by clicking{" "}
            <strong>Install</strong>.
          </li>
          <li>
            Once installed, your <strong>Admin API access token</strong> will be
            visible. Copy it — it will only be shown once!
          </li>
          <li>
            Paste the token into the <strong>Access Token</strong> field in
            ArticleX.
          </li>
          <li>Make sure the connection fields are filled out.</li>
          <li>
            Click <strong>Test</strong> to test the connection from ArticleX.
          </li>
          <li>
            If successful, click <strong>Save</strong> to save the connection.
          </li>
        </ol>
      </div>
    </Modal>
  );
};

export default ShopifyGuideModal;
